/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./liveSourceSelect.vue?vue&type=template&id=bdf82dde&scoped=true&"
import script from "./liveSourceSelect.vue?vue&type=script&lang=js&"
export * from "./liveSourceSelect.vue?vue&type=script&lang=js&"
import style0 from "./liveSourceSelect.vue?vue&type=style&index=0&id=bdf82dde&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf82dde",
  null
  
)

export default component.exports